import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, CardHeader, InputLabel, withStyles } from '@material-ui/core'
import styles from './product-jss'
import TableLiteraryTeam from '../Catalogue/TableLiteraryTeam'

const TabEquiposLiterarios = ({ classes, data }) => {
    const headers = [
        'Versión',
        'Categoria',
        'Equipo Literario',
        'Rol',
    ]
    return (
        <Card>
            <CardHeader subheader="Equipos Literarios" className={classes.header} />
            <CardContent>
                {data ? 
                    <TableLiteraryTeam headers={headers} data={data} />
                    : <InputLabel className={classes.optionItem}>No hay información disponible</InputLabel>}
            </CardContent>
        </Card>
    )
}

TabEquiposLiterarios.propTypes = {
    data: PropTypes.object
}

export default withStyles(styles)(TabEquiposLiterarios);